// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.hotkeysModal_backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.hotkeysModal {
    background: white;
    border-radius: 12px;
    max-width: 800px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.hotkeysModal_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 24px 16px;
    border-bottom: 1px solid #e0e0e0;
}

.hotkeysModal_header h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #333;
}

.hotkeysModal_close {
    background: none;
    border: none;
    font-size: 28px;
    cursor: pointer;
    color: #666;
    line-height: 1;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.hotkeysModal_close:hover {
    color: #333;
}

.hotkeysModal_content {
    padding: 24px;
}

.hotkeysModal_section {
    margin-bottom: 32px;
}

.hotkeysModal_section:last-child {
    margin-bottom: 0;
}

.hotkeysModal_section h3 {
    margin: 0 0 16px 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.hotkeysModal_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
}

.hotkeysModal_item:last-child {
    border-bottom: none;
}

.hotkeysModal_key {
    font-family: 'Courier New', monospace;
    background: #f5f5f5;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    border: 1px solid #ddd;
}

.hotkeysModal_description {
    color: #666;
    font-size: 14px;
}

.hotkeysModal_messageSection {
    margin-top: 16px;
}

.hotkeysModal_messageInput {
    width: 100%;
    min-height: 150px;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    font-family: inherit;
    resize: vertical;
    margin-bottom: 16px;
    box-sizing: border-box;
}

.hotkeysModal_messageInput:focus {
    outline: none;
    border-color: #4CAF50;
    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
}

.hotkeysModal_sendButton {
    background: #4CAF50;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
}

.hotkeysModal_sendButton:hover:not(:disabled) {
    background: #45a049;
}

.hotkeysModal_sendButton:disabled {
    background: #ccc;
    cursor: not-allowed;
}

.hotkeysModal_logsSection {
    margin-bottom: 16px;
}

.hotkeysModal_logsSection h4 {
    margin: 0 0 8px 0;
    font-size: 14px;
    font-weight: 600;
    color: #333;
}

.hotkeysModal_logsPreview {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 8px;
    background: #f9f9f9;
    font-family: 'Courier New', monospace;
    font-size: 12px;
}

.hotkeysModal_logItem {
    display: flex;
    margin-bottom: 4px;
    padding: 2px 4px;
    border-radius: 3px;
}

.hotkeysModal_logItem--log {
    background: rgba(0, 0, 0, 0.05);
}

.hotkeysModal_logItem--warn {
    background: rgba(255, 193, 7, 0.1);
    color: #856404;
}

.hotkeysModal_logItem--error {
    background: rgba(220, 53, 69, 0.1);
    color: #721c24;
}

.hotkeysModal_logItem--info {
    background: rgba(13, 202, 240, 0.1);
    color: #055160;
}

.hotkeysModal_logTime {
    margin-right: 8px;
    color: #666;
    flex-shrink: 0;
}

.hotkeysModal_logType {
    margin-right: 8px;
    font-weight: bold;
    flex-shrink: 0;
}

.hotkeysModal_logMessage {
    word-break: break-word;
    flex: 1;
}

.hotkeysModal_noLogs {
    color: #666;
    font-style: italic;
    text-align: center;
    padding: 16px;
}

.hotkeysModal_screenshotStatus,
.hotkeysModal_screenshotPreview,
.hotkeysModal_sendingStatus {
    color: #333;
    font-size: 14px;
    margin-bottom: 12px;
    padding: 8px 12px;
    background: #f8f9fa;
    border-radius: 6px;
    border-left: 3px solid #007bff;
}

.hotkeysModal_screenshotPreview {
    border-left-color: #28a745;
}

.hotkeysModal_sendingStatus {
    border-left-color: #ffc107;
}
`, "",{"version":3,"sources":["webpack://./src/components/hotkeysModal/HotkeysModal.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["\n.hotkeysModal_backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000;\n}\n\n.hotkeysModal {\n    background: white;\n    border-radius: 12px;\n    max-width: 800px;\n    width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.hotkeysModal_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px 24px 16px;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.hotkeysModal_header h2 {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 600;\n    color: #333;\n}\n\n.hotkeysModal_close {\n    background: none;\n    border: none;\n    font-size: 28px;\n    cursor: pointer;\n    color: #666;\n    line-height: 1;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.hotkeysModal_close:hover {\n    color: #333;\n}\n\n.hotkeysModal_content {\n    padding: 24px;\n}\n\n.hotkeysModal_section {\n    margin-bottom: 32px;\n}\n\n.hotkeysModal_section:last-child {\n    margin-bottom: 0;\n}\n\n.hotkeysModal_section h3 {\n    margin: 0 0 16px 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.hotkeysModal_item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 0;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.hotkeysModal_item:last-child {\n    border-bottom: none;\n}\n\n.hotkeysModal_key {\n    font-family: 'Courier New', monospace;\n    background: #f5f5f5;\n    padding: 6px 12px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #333;\n    border: 1px solid #ddd;\n}\n\n.hotkeysModal_description {\n    color: #666;\n    font-size: 14px;\n}\n\n.hotkeysModal_messageSection {\n    margin-top: 16px;\n}\n\n.hotkeysModal_messageInput {\n    width: 100%;\n    min-height: 150px;\n    padding: 12px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    font-size: 14px;\n    font-family: inherit;\n    resize: vertical;\n    margin-bottom: 16px;\n    box-sizing: border-box;\n}\n\n.hotkeysModal_messageInput:focus {\n    outline: none;\n    border-color: #4CAF50;\n    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);\n}\n\n.hotkeysModal_sendButton {\n    background: #4CAF50;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.hotkeysModal_sendButton:hover:not(:disabled) {\n    background: #45a049;\n}\n\n.hotkeysModal_sendButton:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n}\n\n.hotkeysModal_logsSection {\n    margin-bottom: 16px;\n}\n\n.hotkeysModal_logsSection h4 {\n    margin: 0 0 8px 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: #333;\n}\n\n.hotkeysModal_logsPreview {\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    padding: 8px;\n    background: #f9f9f9;\n    font-family: 'Courier New', monospace;\n    font-size: 12px;\n}\n\n.hotkeysModal_logItem {\n    display: flex;\n    margin-bottom: 4px;\n    padding: 2px 4px;\n    border-radius: 3px;\n}\n\n.hotkeysModal_logItem--log {\n    background: rgba(0, 0, 0, 0.05);\n}\n\n.hotkeysModal_logItem--warn {\n    background: rgba(255, 193, 7, 0.1);\n    color: #856404;\n}\n\n.hotkeysModal_logItem--error {\n    background: rgba(220, 53, 69, 0.1);\n    color: #721c24;\n}\n\n.hotkeysModal_logItem--info {\n    background: rgba(13, 202, 240, 0.1);\n    color: #055160;\n}\n\n.hotkeysModal_logTime {\n    margin-right: 8px;\n    color: #666;\n    flex-shrink: 0;\n}\n\n.hotkeysModal_logType {\n    margin-right: 8px;\n    font-weight: bold;\n    flex-shrink: 0;\n}\n\n.hotkeysModal_logMessage {\n    word-break: break-word;\n    flex: 1;\n}\n\n.hotkeysModal_noLogs {\n    color: #666;\n    font-style: italic;\n    text-align: center;\n    padding: 16px;\n}\n\n.hotkeysModal_screenshotStatus,\n.hotkeysModal_screenshotPreview,\n.hotkeysModal_sendingStatus {\n    color: #333;\n    font-size: 14px;\n    margin-bottom: 12px;\n    padding: 8px 12px;\n    background: #f8f9fa;\n    border-radius: 6px;\n    border-left: 3px solid #007bff;\n}\n\n.hotkeysModal_screenshotPreview {\n    border-left-color: #28a745;\n}\n\n.hotkeysModal_sendingStatus {\n    border-left-color: #ffc107;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
